import axios from 'axios';

const getServiceOrdersApi = async (paramsFilter, token, langIsoCode) => {
  try {
    const url = `/Service/myOrders`;
    const res = await axios.get(url, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        lang: langIsoCode
      }
    });
    return res;
  } catch (error) {
    throw error;
  }
};

export default getServiceOrdersApi;
